module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project) ? _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "col-6 col-3-md header__back fw-500 c-light-grey",
    attrs: {
      "to": "/work",
      "tag": "div"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.activeArrow = true
      },
      "mouseleave": function($event) {
        _vm.activeArrow = false
      }
    }
  }, [_c('arrow', {
    attrs: {
      "size": "large",
      "active": _vm.activeArrow
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row description"
  }, [_c('div', {
    staticClass: "col-12 col-10-md left-2-md"
  }, [_c('h1', {
    staticClass: "header__heading"
  }, [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-2-md"
  }, [(_vm.project.url) ? _c('a', {
    staticClass: "description__website",
    attrs: {
      "href": ("https://" + (_vm.project.url)),
      "target": "_blank"
    }
  }, [_vm._v("Visit website")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-8-md description__body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })]), _vm._v(" "), (_vm.project.awards) ? _c('div', {
    staticClass: "col-6 col-4-md left-2-md awards"
  }, [_c('span', [_vm._v("Awards")]), _vm._v(" "), _c('ul', {
    staticClass: "awards__list"
  }, _vm._l((_vm.project.awards), function(award) {
    return _c('li', {
      key: award,
      staticClass: "awards__item"
    }, [_vm._v(_vm._s(award))])
  }))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41d64ee8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/Header.vue
// module id = 386
// module chunks = 2